import { Component } from '@angular/core';

/**
 * Component that represents the not found page.
 */
@Component({
  selector: 'p2f-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent {}
